import React from 'react';
import { Container } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import './policy.scss';

function Policy() {
    return (
        <Container className="policy-container">
            <h2>Політика конфіденційності</h2>
            <h4>Загальні положення</h4>
            <p>
                Асоціація гірських провідників "Ровінь" (надалі Компанія)
                створила мобільний додаток "Порятунок" як безкоштовну програму.
                Цей додаток надається Компанією безкоштовно і призначена для
                використання в такому як є вигляді.
            </p>
            <p>
                Ця сторінка використовується для інформування користувачів про
                нашу політику щодо збору, використання та розкриття Персональної
                інформації, якщо хтось вирішив скористатися нашим додатком. Якщо
                Ви вирішите використовувати наш додаток, Ви погоджуєтесь на збір
                та використання інформації стосовно цієї політики. Персональна
                інформація, яку ми збираємо, використовується для надання та
                вдосконалення додатку. Ми не будемо використовувати та
                передавати Вашу інформацію нікому, крім випадків, описаних у цій
                Політиці конфіденційності.
            </p>
            <p>
                Терміни, що використовуються в цій Політиці конфіденційності,
                мають те саме значення, що і в наших Загальних положеннях та
                умовах, якщо інше не визначено в цій Політиці конфіденційності.
            </p>
            <p>
                Компанія не збирає будь-яку інформацію, до обробки якої
                законодавством встановлені певні вимоги, як-то інформацію про
                расове або етнічне походження, політичні, релігійні чи
                світоглядні переконання, членство в політичних партіях та
                професійних спілках, засудження до кримінального покарання, а
                також даних, що стосуються статевого життя, біометричних або
                генетичних даних (відповідно до статті 7 Закону України «Про
                захист персональних даних»).
            </p>
            <h4>Збір та використання персональних даних</h4>
            <p>
                Для покращення використання Вами нашого додатку ми можемо
                вимагати від Вас надання нам певної інформації, що ідентифікує
                особу, включаючи Ваше ім'я та прізвище, адресу електронної
                пошти, номер контактного телефону, дату народження, стать,
                геолокаційні дані і т.д., але не обмежуючись цим. Інформація,
                яку ми вимагаємо, буде збережена нами та використана згідно з
                цією політикою конфіденційності.
            </p>
            <p>
                Додаток використовує сторонні служби, які можуть збирати
                інформацію, яка використовується для Вашої ідентифікації.
                Посилання на політику конфіденційності сторонніх постачальників
                послуг, що використовуються додатком:
            </p>
            <ul>
                <li>
                    <a href="https://www.google.com/policies/privacy/">
                        Служби Google Play
                    </a>
                </li>
                <li>
                    <a href="https://firebase.google.com/policies/analytics">
                        Google Analytics для Firebase
                    </a>
                </li>
                <li>
                    <a href="https://firebase.google.com/support/privacy/">
                        Firebase Crashlytics
                    </a>
                </li>
            </ul>
            <h4>Дані журналу</h4>
            <p>
                Ми хочемо повідомити Вам, що у випадку помилки під час
                використання Вами нашого додатком, ми збираємо дані та
                інформацію (через сторонні продукти) на Вашому телефоні (“Log
                Data”). Ці журнальні дані можуть містити таку інформацію, як
                адреса інтернет-протоколу (“IP”) Вашого пристрою, назва
                пристрою, версія операційної системи, конфігурація під час
                використання даного додатку, час і дату використання додатку та
                інша статистика.
            </p>
            <h4>Використання файлів Cookies</h4>
            <p>
                Файли cookies - це файли з невеликою кількістю даних, які
                зазвичай використовуються як анонімні унікальні ідентифікатори.
                Вони надсилаються у Ваш браузер із веб-сайтів, які Ви
                відвідуєте, і зберігаються у внутрішній пам’яті Вашого пристрою.
            </p>
            <p>
                Цей додаток не використовує ці "файли cookies" явно. Однак
                додаток може використовувати сторонній код та бібліотеки, які
                використовують "файли cookies" для збору інформації та
                вдосконалення своїх послуг. Ви можете прийняти або відхилити ці
                файли cookies та знати, коли файл cookies надсилається на Ваш
                пристрій. Якщо Ви вирішите відмовитись від наших файлів cookies,
                можливо, Ви не зможете використовувати деякі частини цього
                додатку.
            </p>
            <h4>Взаємодія з третіми особами стосовно персональних даних</h4>
            <p>
                Ми можемо наймати сторонні компанії та приватних осіб з таких
                причин:
            </p>
            <ul>
                <li>для сприяння використання даного додатку;</li>
                <li>
                    для надання послуг, пов’язаних із даним додатком, від нашого
                    імені;
                </li>
                <li>
                    для допомоги нам в аналізі того, як використовується наш
                    додаток.
                </li>
            </ul>
            <p>
                Ми хочемо повідомити користувачів цього додатку, що ці треті
                сторони мають доступ до Вашої Персональної інформації. Причина
                полягає у виконанні завдань, покладених на них від нашого імені.
                Однак вони зобов'язані не розголошувати та не використовувати
                інформацію для будь-яких інших цілей.
            </p>
            <h4>Взаємодія додатку з іншими ресурсами</h4>
            <p>
                Цей додаток може містити посилання на інші веб-сайти. Якщо Ви
                натиснете на стороннє посилання, Ви перейдете на цей сайт.
                Зверніть увагу, що цими зовнішніми веб-сайтами ми не керуємо.
                Тому ми настійно рекомендуємо переглянути політику
                конфіденційності цих веб-сайтів. Ми не контролюємо та не несемо
                відповідальності за вміст, політику конфіденційності чи практику
                будь-яких сторонніх сайтів або послуг.
            </p>
            <h4>Безпека</h4>
            <p>
                Ми цінуємо Вашу довіру до надання нам Вашої Персональної
                інформації, тому ми прагнемо використовувати комерційно
                прийнятні засоби захисту. Але пам’ятайте, що жоден спосіб
                передачі через Інтернет, а також спосіб електронного зберігання
                даних не є на 100% надійним, і ми не можемо гарантувати його
                абсолютну безпеку.
            </p>
            <h4>Безпека неповнолітніх</h4>
            <p>
                Цей додаток не стосуються людей, яким не виповнилося 14 років.
                Ми не збираємо свідомо інформацію, що дозволяє ідентифікувати
                особу до 14 років. Якщо ми виявимо, що дитина до 14 років надала
                нам особисту інформацію, ми негайно видалимо її з наших
                серверів. Якщо Ви є батьком або опікуном і Вам відомо, що Ваша
                дитина надала нам особисту інформацію, будь ласка, зв'яжіться з
                нами, щоб ми змогли виконати необхідні дії.
            </p>
            <h4>Зміни до цієї Політики конфіденційності</h4>
            <p>
                Ми можемо час від часу оновлювати нашу Політику
                конфіденційності, у тому числі при зміні вимог законодавства.
                Таким чином, Вам рекомендується періодично переглядати цю
                сторінку щодо будь-яких змін. Ми повідомимо Вас про будь-які
                зміни, опублікувавши нову Політику конфіденційності на цій
                сторінці.
            </p>
            <p>Ця політика діє з 2021-07-16</p>
            <h4>Зв'яжіться з нами</h4>
            <p>
                Якщо у Вас є якісь запитання чи пропозиції щодо нашої Політики
                конфіденційності, не соромтеся зв'язатися з нами за адресою{' '}
                <a href="mailto:rovin191@gmail.com">rovin191@gmail.com</a>
            </p>
            <br />
        </Container>
    );
}

export default withRouter(Policy);
